export const labels = {
  autosuggest: {
    suggestions: 'Suchvorschläge',
    helpText:
      'Es erscheinen Suchvorschläge, wenn mindestens @TextMinLength Zeichen eingegeben wurden.',
  },
};
